import {useStyles} from '../../hooks/styles';
import {AlignFunc, DeviceSize} from '../../theme/helpers';
import {Theme} from '../../theme/interface';

export const GetStyles = (theme: Theme, headerBlockSize: number, align: AlignFunc) => {
  return useStyles(({mediaOnly}) => {
    return {
      container: {
        minHeight: 360,
        borderRadius: 5,
        borderWidth: 1,
        borderColor: theme.color.borderColor,
        backgroundColor: theme.color.primaryNonGreyBackground,
        flexDirection: 'column',
        alignItems: 'stretch',
        shadowColor: theme.color.primaryBlackColor,
        shadowOpacity: 0.05,
        shadowOffset: {width: 0, height: 4},
        shadowRadius: 10,
        elevation: 5,
      },
      header: {
        height: headerBlockSize,
        position: 'relative',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
      },
      headerImageBlock: {
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: headerBlockSize,
      },
      logo: {
        position: 'relative',
        zIndex: 1,
        width: align(166),
        height: align(166),
      },
      body: {
        flexGrow: 1,
        flexDirection: 'column',
        alignItems: 'stretch',
      },
      footer: {
        borderTopWidth: 1,
        borderTopColor: theme.color.borderColor,
        borderStyle: 'solid',
        paddingVertical: 20,
        paddingHorizontal: 16,
      },
      button: {
        margin: 0,
      },
      name: {
        ...mediaOnly(DeviceSize.desktop, theme.fonts.h5, theme.fonts.h6),
        color: theme.color.textColor,
        textAlign: 'center',
        marginTop: 18,
        paddingHorizontal: 16,
        textTransform: 'uppercase',
      },
      descriptionContainer: {
        flexGrow: 1,
        paddingHorizontal: 16,
        paddingVertical: 6,
        marginTop: 18,
      },
      description: {
        ...mediaOnly(DeviceSize.desktop, theme.fonts.body, theme.fonts.bodySmallLight),
        color: theme.color.labelText,
        textAlign: 'center',
      },
      phoneContainer: {
        flexGrow: 1,
        paddingHorizontal: 16,
        paddingVertical: 6,
      },
      phone: {
        justifyContent: 'center',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 10,
        marginBottom: 10,
      },
      phoneIcon: {
        width: 18,
        height: 18,
        flexShrink: 0,
        marginRight: 8,
        color: theme.color.primaryColor,
      },
      phoneText: {
        ...theme.fonts.body,
        color: theme.color.textColor,
      },
    };
  });
};
